"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Y_PADDING = exports.TICKS_FONT_COLOR = exports.TICKS_COLOR = exports.RED_COLOR = exports.POINT_RADIUS = exports.POINT_HOVER_RADIUS = exports.POINT_ENDS_RADIUS = exports.POINT_BORDER_WIDTH = exports.MAGENTA_COLOR = exports.DEFAULT_BG_COLOR = exports.CHART_HEIGHT = exports.BORDER_COLOR = exports.BLUE_COLOR = void 0;
const RED_COLOR = '#FF7E00';
exports.RED_COLOR = RED_COLOR;
const BLUE_COLOR = '#0468FF';
exports.BLUE_COLOR = BLUE_COLOR;
const DEFAULT_BG_COLOR = 'rgba(244,244,244,0.8)';
exports.DEFAULT_BG_COLOR = DEFAULT_BG_COLOR;
const BORDER_COLOR = 'rgba(21, 34, 66, 0.1)';
exports.BORDER_COLOR = BORDER_COLOR;
const TICKS_COLOR = 'rgba(21, 34, 66, 0.2)';
exports.TICKS_COLOR = TICKS_COLOR;
const TICKS_FONT_COLOR = 'rgba(21, 34, 66, 0.4)';
exports.TICKS_FONT_COLOR = TICKS_FONT_COLOR;
const POINT_RADIUS = 0;
exports.POINT_RADIUS = POINT_RADIUS;
const POINT_ENDS_RADIUS = 4;
exports.POINT_ENDS_RADIUS = POINT_ENDS_RADIUS;
const POINT_HOVER_RADIUS = 4;
exports.POINT_HOVER_RADIUS = POINT_HOVER_RADIUS;
const POINT_BORDER_WIDTH = 1;
exports.POINT_BORDER_WIDTH = POINT_BORDER_WIDTH;
const CHART_HEIGHT = 186;
exports.CHART_HEIGHT = CHART_HEIGHT;
const Y_PADDING = 2;
exports.Y_PADDING = Y_PADDING;
const MAGENTA_COLOR = '#8B008B';
exports.MAGENTA_COLOR = MAGENTA_COLOR;